module.exports = __webpack_public_path__ + "img/generations.1a3cee85.jpg";